import { Box, Heading } from '@ghq-abi/design-system';

export function ListCardDetailsItem({
  label,
  value,
}: {
  label?: string;
  value?: string;
}) {
  return (
    <Box>
      <Heading css={{ fontSize: '$sm', fontWeight: '$medium' }} as="strong">
        {label}
      </Heading>
      <Box css={{ color: '#7D8597', fontSize: '$xs' }}>{value}</Box>
    </Box>
  );
}
